import { getCountryCallingCode, type CountryCode } from 'libphonenumber-js';

export interface CountryEntry {
  code: CountryCode;
  name: string;
  dialCode: string;
  flag: string;
}

const COUNTRY_NAMES: Record<string, string> = {
  GH: 'Ghana',
  NG: 'Nigeria',
  US: 'United States',
  GB: 'United Kingdom',
  CN: 'China',
  DE: 'Germany',
  FR: 'France',
  IT: 'Italy',
  ES: 'Spain',
  NL: 'Netherlands',
  CA: 'Canada',
  ZA: 'South Africa',
  KE: 'Kenya',
  CI: 'Ivory Coast',
  SN: 'Senegal',
  TG: 'Togo',
  BJ: 'Benin',
  BF: 'Burkina Faso',
  AE: 'United Arab Emirates',
  IN: 'India',
  JP: 'Japan',
  KR: 'South Korea',
  AU: 'Australia',
};

function countryCodeToFlag(code: string): string {
  return [...code]
    .map((char) => String.fromCodePoint(0x1f1e6 + char.charCodeAt(0) - 65))
    .join('');
}

export const COUNTRIES: CountryEntry[] = Object.entries(COUNTRY_NAMES).map(([code, name]) => ({
  code: code as CountryCode,
  name,
  dialCode: `+${getCountryCallingCode(code as CountryCode)}`,
  flag: countryCodeToFlag(code),
}));
